export default __webpack_public_path__ + "static/opencart-7b59271f6b97dc1000da14bfc11926cc.png";